module.exports = __webpack_public_path__ + "static/media/socios-rodrigomartins.1a98cf74.jpg";